import { serialize } from "components/editor/serializers";
import { SlateDocument } from "components/editor/types";
import ExpandableElement from "components/shared/ExpandableElement";
import Text from "hardcover-ui/components/Text";
import { ReactElement } from "react";

export interface Props {
  reviewSlate: SlateDocument;
  expandClass?: string;
  expanded?: boolean;
  allowCollapse?: boolean;
}

export default function BookReviewText({
  reviewSlate,
  expandClass = "max-h-24",
  expanded = true,
  allowCollapse = true,
}: Props) {
  let ReviewElement: ReactElement;
  if (reviewSlate.document?.children?.length > 0) {
    try {
      ReviewElement = serialize(reviewSlate);
    } catch (e) {
      ReviewElement = (
        <Text variant="secondary" as="p" className="py-2">
          We ran into an error trying to show this review: {e.message}. Try
          editing to fix this error, or let us know at jules@hardcover.app with
          a link to this page.
        </Text>
      );
    }
  }

  if (ReviewElement) {
    return (
      <ExpandableElement
        expanded={expanded}
        expandClass={expandClass}
        allowCollapse={allowCollapse}
      >
        {ReviewElement}
      </ExpandableElement>
    );
  }

  return (
    <Text variant="secondary" as="p" className="py-2 italic">
      No review written.
    </Text>
  );
}
